import React from "react";
import { useParams } from "react-router-dom";
import DayForm from "./DayForm";
import * as DayService from "../../Services/DayService";

const EndDay = () => {
  const { dayId } = useParams();
  const submitEnd = (formData) => DayService.EndDay(dayId, formData);
  return <DayForm mode="end" onSubmit={submitEnd} />;
};

export default EndDay;
